import useUrlPrefix from '@app/hooks/useUrlPrefix';
import { useSelector } from 'react-redux';
import { getLanguageCode } from '@app/redux/localization/selectors';
import React from 'react';
import useNavigationFilters from '@app/catalog/hooks/useNavigationFilters';
import { BrowseDropdownContainer } from '../../Browse.styles';
import Categories from '../Categories';

/**
 *
 * @constructor
 */
const BrowseDropdown = () => {
  const urlPrefix = useUrlPrefix();
  const languageCode = useSelector(getLanguageCode);
  const { data } = useNavigationFilters();

  if (!data) {
    return null;
  }

  return (
    <BrowseDropdownContainer>
      <Categories
        categories={data}
        urlPrefix={urlPrefix}
        languageCode={languageCode}
      />
    </BrowseDropdownContainer>
  );
};

export default BrowseDropdown;
